import API from '../..';

const ENTITY = 'integrations/zap';

export const login = (companyId) =>
    API.get(`/api/v1/${ENTITY}/login/`, {
        params: { company: companyId },
    });
